module.exports = __webpack_public_path__ + "img/safe_tool_4.b35071f4.jpg";